import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useAdditionalPatientPay from "./hooks/useAdditionalPatientPay";

const AdditionalPatientPay = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  setFalg,
  selectParamsData,
  setScheduleDesc,
  disabledDropdown,
  onNavigate,
}) => {
  const additionalPatientPayData = useAdditionalPatientPay(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    setFalg,
    selectParamsData,
    setScheduleDesc,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={additionalPatientPayData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {additionalPatientPayData.screen_title} -{" "}
          <span className="heading-cod">
            {additionalPatientPayData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={additionalPatientPayData.formFields}
        dropdownValues={additionalPatientPayData.dropdownValues}
        paramsData={additionalPatientPayData.paramsData}
        updataParamData={additionalPatientPayData.updateParamData}
        disabledDropdown={disabledDropdown}
      />
      <ButtonsSection ctaButtons={additionalPatientPayData.ctaButtons} />
      <DisplayTable
        selectMode={additionalPatientPayData.selectMode}
        data={additionalPatientPayData.data}
        parmKey={additionalPatientPayData.parmKey}
        menuOptions={additionalPatientPayData.menuOptions}
        tableHeaders={additionalPatientPayData.columnDef}
        setRowData={additionalPatientPayData.setRowData}
        selectedPriceSchedules={additionalPatientPayData.selectedRows}
        setSelectedPriceSchedules={additionalPatientPayData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={additionalPatientPayData.first}
          rows={additionalPatientPayData.rows}
          totalRecords={additionalPatientPayData.totalRecords}
          currentPage={additionalPatientPayData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={additionalPatientPayData.onPageChange}
        />
      </div>
      {additionalPatientPayData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={additionalPatientPayData.isConfirmationModalOpen}
          onRequestClose={additionalPatientPayData.closeConfirmationModal}
          onBack={additionalPatientPayData.closeConfirmationModal}
          onSave={additionalPatientPayData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={additionalPatientPayData.setSelectedOption}
        />
      )}
      {additionalPatientPayData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={additionalPatientPayData.isHideConfirmationModalOpen}
          onRequestClose={additionalPatientPayData.closeHideConfirmationModal}
          onBack={additionalPatientPayData.closeHideConfirmationModal}
          onSave={additionalPatientPayData.hideAdditionalPatientPay}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={additionalPatientPayData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default AdditionalPatientPay;
